export default {
    data() {
        return {
            search: '',
            appliedFilters: {},
            listRequestSeq: 0,
        };
    },
    created() {
        this.queueSearch = _.debounce(() => {
            this.serverParams.page = 1;
            this.paginationOptions.setCurrentPage = 1;
            this.paginatedData();
        }, 250);
    },
    watch: {
        search() {
            this.queueSearch();
        },
    },
    beforeDestroy() {
        if (this.queueSearch && this.queueSearch.cancel) {
            this.queueSearch.cancel();
        }
    },
    methods: {
        listParams() {
            const params = {
                page: this.serverParams.page,
                per_page: this.serverParams.perPage,
                api: true,
            };
            const search = (this.search || '').trim();

            if (search) {
                params.search = search;
            }

            Object.entries(this.appliedFilters || {}).forEach(([key, value]) => {
                if (value !== null && value !== undefined && value !== '') {
                    params[key] = value;
                }
            });

            return params;
        },
        nextListRequest() {
            this.listRequestSeq += 1;

            return this.listRequestSeq;
        },
        async fetchList(routeName, routeParams = {}) {
            const requestId = this.nextListRequest();
            this.tableDataLoading = true;

            try {
                const response = await axios.get(route(routeName, routeParams), {
                    params: this.listParams(),
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                });

                if (requestId !== this.listRequestSeq) {
                    return null;
                }

                this.totalRecords = response.data.total;
                this.paginationOptions.perPage = response.data.per_page;
                this.serverParams.perPage = response.data.per_page;
                this.serverParams.page = response.data.current_page;
                this.paginationOptions.setCurrentPage = response.data.current_page;

                return response.data.data;
            } catch (e) {
                console.log(e);

                return null;
            } finally {
                if (requestId === this.listRequestSeq) {
                    this.tableDataLoading = false;
                }
            }
        },
        async loadList(routeName, rowKey, routeParams = {}) {
            const rows = await this.fetchList(routeName, routeParams);

            if (rows) {
                this[rowKey] = rows;
            }
        },
        async applyFilters() {
            this.appliedFilters = {...(this.filters || {})};
            this.serverParams.page = 1;
            this.paginationOptions.setCurrentPage = 1;
            await this.paginatedData();
        },
        async resetFilters() {
            if (this.filters) {
                Object.keys(this.filters).forEach((key) => {
                    this.filters[key] = null;
                });
            }

            this.appliedFilters = {...(this.filters || {})};
            this.serverParams.page = 1;
            this.paginationOptions.setCurrentPage = 1;
            await this.paginatedData();
        },
    },
};
